import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {OutlinedInput, Select, MenuItem, FormControl, Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Radio from '@mui/material/Radio';
import CircularProgress from '@mui/material/CircularProgress';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import OverlayLoadingScreen from '../components/OverlayLoadingScreen';
import AccountDetails from './AccountDetails';
import AccountSaveEdit from './AccountSaveEdit'; 
import AccountSaveNew from './AccountSaveNew';
import AgentSelect from '../agents/AgentSelect';
import AgentSelectMultiple from '../agents/AgentSelectMultiple';
import UploadAccountData from './UploadAccountData';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
///import { color } from 'highcharts';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const location = useLocation();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');

	const alphaArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
	const alphaBtnStyle = {marginTop:-10,marginBottom:5,padding:0,display: 'inline-block', minHeight: 30, minWidth: 30, marginRight:5};
	const alphaBtnStyleActive = {marginTop:-10,marginBottom:5,padding:0,display: 'inline-block', minHeight: 30, minWidth: 30, marginRight:5, backgroundColor:'#0c65d8', color:'#FFFFFF'};
	
	const childRefDetails = React.useRef();
	const childRefSaveNew = React.useRef();
	const childRefUpload = React.useRef();
	const childRefSaveEdit = React.useRef();
	const childRefUser = React.useRef();
	const childRefAddUser = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");

	const [selectedRows, setSelectedRows] = React.useState([]);
	const [dataLoading, setDataLoading] = React.useState(true);
	const [overlayLoading, setOverlayLoading] = React.useState(false);
	const [filterType, setFilterType] = React.useState("noselect");
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [alphaFilter, setAlphaFilter] = React.useState("");
	
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	const [page, setPage] = React.useState(0);
	const [rowCount, setRowCount] = React.useState(0);
	const [pageSize, setPageSize] = React.useState(100);
	const [downloadShow, setDownloadShow] = React.useState(false);
	const [downloadReady, setDownloadReady] = React.useState(false);
	const [downloadUrl, setDownloadUrl] = React.useState("");

	// var myCurrentDate=new Date();
	// var myPastFromDate=new Date(myCurrentDate);
    // myPastFromDate.setDate(myPastFromDate.getDate() - 1827);
	// const [fromDate, setFromDate] = React.useState(moment(myPastFromDate).format('YYYY-MM-DD'));
	// const [toDate, setToDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));


	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	const handlePageChange = (obj) => {
		  ///alert("newPage: "+JSON.stringify(obj));
		  setDataObj({});
		  setSelectedRows([]);
		  setPageSize(obj.pageSize);
		  setPage(obj.page);
		  setFilter(!filter);
	};

	const columns = [
		{ field: 'srno', headerName: '#', width: 40 },
		{ field: 'accountNumber', headerName: 'Account Number', width: 160},
		{ field: 'accountName', headerName: 'Account Name', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'company', headerName: 'Company', width: 160, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'accountCategory', headerName: 'Category', width: 160, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'rank', headerName: 'Rank', width: 160},
		{ field: 'comment', headerName: 'Comment', width: 160, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
	    { field: 'ownerAlias', headerName: 'Agent', width: 160 },
	    { field: 'accessWithNames', headerName: 'Shared with', width: 160 },   			
		
	  ];
	

	React.useEffect(() => {				
		if(userObj.registerId && userObj.loginId && userObj.fullName && userObj.token){
			getApiData(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);
		}
	}, [userObj,filter, location]);

	async function getApiData(registerId,uid,fullName,token){ 
			let queryString = '';
			if(filterType && filterType!=='noselect'){
				queryString += '&filter='+filterType;
			}else if(location && location.state && location.state.filter){
				queryString += '&filter='+location.state.filter;
				setFilterType(location.state.filter);
			}
			if(alphaFilter && alphaFilter.length>0){
				queryString += '&alphaFilter='+alphaFilter;
			}

		  let apiUrl=API_URL+'/crm-list-accounts?search=1&minRows='+(page*pageSize)+'&maxRows='+pageSize+'&keyword='+keyword+queryString;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': registerId,
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			setDataLoading(true);
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
					if(page===0){
						setRowCount(response.data.rowCount);
					}
					setRows(response.data.list);				 				
					setPrivileges(response.data.privileges);

				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
					
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				  setSeverityAlert("error");
				  setShowAlert(true);
				  setAlertMessage(""+error);			
				  return false;
		  	})	
	}

	function saveData(opt){
		if(opt===1){
			setSelectedRows([]);
			setDataObj({});
			childRefSaveNew.current.handleClickOpen();
		}else if(opt===2 && selectedRows && selectedRows.length>0){
			setDataObj(rows[selectedRows[0]-1]);
			childRefSaveEdit.current.handleClickOpen();
		}else if(opt===3 && selectedRows && selectedRows.length>0){
			setDataObj(rows[selectedRows[0]-1]);
			childRefDetails.current.handleClickOpen();
		}
	}

	function deleteData(){
		if(dataObj && userObj.token && selectedRows && selectedRows.length>0){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token
				}
			}; 

		  const data = new FormData();
		  //data.append('id', studentObj.autoId);
		 /// data.append('studentId', studentObj.studentId);
				 
		  axios.post(API_URL+'/admin-delete-student', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Student has been deleted.");
			  		window.location.reload();	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This student could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					console.log("AXIOS ERROR: ", error);
				})	
		}		
		
	}

	function downloadFile(opt){
		if(opt===1){ //START DOWNLOAD			
			setDownloadReady(true);
			setDownloadShow(true);
			if(userObj.loginId){
				downloadApiCall();
			}
		}else if(opt===2){ //HIDE DOWNLOAD ALERT
			setDownloadShow(false);
		}else if(opt===3){ //DOWNLOAD NOW
			window.open(downloadUrl,"_blank");
			setDownloadShow(false);
		}
	}

	async function downloadApiCall(){ 
		
		let queryString = '';
		if(filterType && filterType!=='noselect'){
			queryString += '&filter='+filterType;
		}else if(location && location.state && location.state.filter){
			queryString += '&filter='+location.state.filter;
			setFilterType(location.state.filter);
		}
		if(alphaFilter && alphaFilter.length>0){
			queryString += '&alphaFilter='+alphaFilter;
		}

		let apiUrl=API_URL+'/crm-download-accounts?keyword='+keyword+queryString;
		let axiosHeader = {
				  'Content-Type': 'multipart/mixed',
				  'device': 'web',
				  'registerId': userObj.registerId,
				  'uid': userObj.loginId,
				  'fullName': userObj.fullName,
				  'token': userObj.token,
		  };
		  const config = {
			  method: 'get',
			  url: apiUrl,
			  headers: axiosHeader
		  }
		  await axios(config)
			 .then(response => {
			  setDataLoading(false);
			  if(response && response.status===200 && response.data && response.data.responseTxt==="success"){  
				 setDownloadReady(false);
				 setDownloadUrl(response.data.downloadUrl);
			  }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
				  window.location.href='invalidtoken';
			  }else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
				  childRefAuthorization.current.handleClickOpen();
			  }
		  }).catch((error) => {
			  setSeverityAlert("error");
			  setShowAlert(true);
			  setAlertMessage(""+error);			
			  return false;
			})	
  	}

	function uploadFile(){
		childRefUpload.current.handleClickOpen();
	}

	const handleOnCellClick = (obj) => {
		if(obj.field==='accountNumber' || obj.field==='accountName'){ 
			setDataObj(rows[obj.id-1]);
			if(dataObj){
				childRefDetails.current.handleClickOpen();
			}
		}		
	};

	function selectUser(){
		childRefUser.current.handleClickOpen();
	}
	function addUser(){
		if(selectedRows && selectedRows.length>0){
			setDataObj(rows[selectedRows[0]-1]);
			childRefAddUser.current.handleClickOpen();
		}
	}

	function transferLeadsToAgent(obj){

		if(selectedRows && selectedRows.length>0 && userObj.token){

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

			let selectedIds="";
			if(selectedRows){
				for(let i=0; i<selectedRows.length; i++){
					selectedIds+=rows[selectedRows[i]-1]?.autoId+",";
				}
				selectedIds=selectedIds.substring(0,selectedIds.length-1);
			}

		  const data = new FormData();
		  data.append('ownerId', obj.autoId);
		  data.append('ownerAlias', obj.fullName);
		  data.append('ids', selectedIds);
				 
		  setOverlayLoading(true);	
		  axios.post(API_URL+'/crm-transfer-accounts', data, axiosHeader)
				.then((response) => {
					setOverlayLoading(false);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Account has been transferred.");
					setFilter(!filter);	
					setDataObj({});				
					setSelectedRows([]);
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Account could not be transferred.");			
					return false;
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage("ERROR: " + error);
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
	}


	function shareToAgent(ownerIds,ownerNames){

		if(selectedRows && selectedRows.length>0 && userObj.token){

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

			let selectedIds="";
			if(selectedRows){
				for(let i=0; i<selectedRows.length; i++){
					if(rows[selectedRows[i]-1] && rows[selectedRows[i]-1].autoId>0){
						selectedIds+=rows[selectedRows[i]-1].autoId+",";
					}
				}
				selectedIds=selectedIds.substring(0,selectedIds.length-1);
			}
		  const data = new FormData(); 
		  data.append('ownerIds', ownerIds);
		  data.append('ownerNames', ownerNames);
		  data.append('ids', selectedIds);
				 
		  setOverlayLoading(true);	
		  axios.post(API_URL+'/crm-share-accounts', data, axiosHeader)
				.then((response) => {
					setOverlayLoading(false);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Account has been shared.");
					setFilter(!filter);	
					setDataObj({});				
					setSelectedRows([]);
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Account could not be shared.");			
					return false;
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage("ERROR: " + error);
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

	function search(){
		setDataObj({});
		setPage(0);
		setAlphaFilter("");
		setFilter(!filter);
		navigate(location.state, {}); // reset location param
	}

	function handleFilterType(val) {		
		setFilterType(val);
		setAlphaFilter("");
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

	function handleAlphaFilter(val){
		setAlphaFilter(val);
		setFilter(!filter);
	}

	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}

	function updatedList(list) {
		setDataObj({});
		setSelectedRows([]);
		setRows(list);
	}
	function reloadList() {
		setRowCount(0);	
		if(userObj.registerId && userObj.loginId && userObj.fullName && userObj.token){
			getApiData(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);
		}
	}
	
	return (
		<div> 
				<MetaTags>
            		<title>Accounts</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Accounts" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl size='small' style={{width:200,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={filterType}
											onChange={event => handleFilterType(event.target.value)}
										>
											<MenuItem value={'noselect'}>All Accounts</MenuItem>											
											<MenuItem value={'untouched7days'}>Untouched Last 7 Days</MenuItem>
											<MenuItem value={'untouched15days'}>Untouched Last 15 Days</MenuItem>
											<MenuItem value={'noSale30days'}>No Sale Last 30 Days</MenuItem>
											<MenuItem value={'noSale60days'}>No Sale Last 60 Days</MenuItem>
											<MenuItem value={'noSale90days'}>No Sale Last 90 Days</MenuItem>											
										</Select> 
									</FormControl>

									<FormControl style={{marginRight:4,marginBottom:4,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 size="small"
										 endAdornment={
											<InputAdornment position="end">
											<SearchIcon />
											</InputAdornment>
										  }
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>
										{(privileges && privileges.indexOf("create")>-1)?<>	
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										</>:null} 
										 
									{(selectedRows && selectedRows.length>0)?<>	
										{(privileges && ((privileges.indexOf("update")>-1 && dataObj && userObj && userObj.userId===dataObj.ownerId) || privileges.indexOf("modifyall")>-1) )?<>
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
											<i onClick={()=>{selectUser()}} title="Transfer" className="fa fa-exchange btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
											<i onClick={()=>{addUser()}} title="Share with Agents" className="fa fa-users btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										</>:null}
										<i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
									</>:null}

										{(privileges && privileges.indexOf("download")>-1 && rowCount>0)?<>
										<i onClick={()=>{downloadFile(1)}} title="Download" className="fa fa-download btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										</>:null}

										{(privileges && privileges.indexOf("create")>-1)?<>
											<i onClick={()=>{uploadFile()}} title="Upload" className="fa fa-cloud-upload btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										</>:null}

										{/* <i onClick={()=>{window.location='caseskanban'}} title="View Kanban Format" className="fa fa-trello btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="View Calendar" className="fa fa-calendar btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="Advance Search" className="fa fa-search btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} /> */}

									</div>	
								</Grid>
							</Grid>
					</Box>
					<Box>
						<Grid container spacing={2}>
							<Grid item md={12} xs={12} >
							{alphaArr.map((val,i)=>(	
								<Button onClick={() => {handleAlphaFilter(val)}} style={alphaFilter===val?alphaBtnStyleActive:alphaBtnStyle} title={'filter by '+val} size="small" variant="outlined"  >{val}</Button>
							))}
							</Grid>
						</Grid>					
					</Box>
					
					<Box>											
					<div className="tblReport" style={{height: '74vh', width: '100%' }}>
						<DataGrid							
							rows={rows?rows:[]}
							columns={columns}
							pageSize={pageSize}
							rowsPerPageOptions={[pageSize]}
							rowHeight={40}
							rowCount={rowCount}		
							pageSizeOptions={[25,50,100,200]}						
							paginationMode="server"
							onPaginationModelChange={handlePageChange}
  							loading={dataLoading}
							disableSelectionOnClick															
							style={{fontSize:12}}	
							//onRowClick={itm => selectRow(itm)}	
							onCellClick={handleOnCellClick}		
							checkboxSelection
							onRowSelectionModelChange={(newRowSelectionModel) => {
								setSelectedRows(newRowSelectionModel);
							  }}
							 rowSelectionModel={selectedRows}  
							slots={{
								noResultsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
								  </Stack>
								)}}	
						/>

						{/* <DataGrid
							rows={rows?rows:[]}
							columns={columns}
							pageSize={pageSize}
							rowsPerPageOptions={[pageSize]}
							rowHeight={40}
							// ActionsComponent={()=>{alert('Hello')}}	
							rowCount={rowCount}		
							pageSizeOptions={[25,50,100,200]}						
							paginationMode="server"
							onPaginationModelChange={handlePageChange}
  							loading={dataLoading}
							disableSelectionOnClick	
							style={{fontSize:12}}	
							//onRowClick={itm => selectRow(itm)}	
							onCellClick={handleOnCellClick}		
							checkboxSelection
							onRowSelectionModelChange={(newRowSelectionModel) => {
								setSelectedRows(newRowSelectionModel);
							  }}
							 rowSelectionModel={selectedRows}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No account found!</span>
								  </Stack>
								)}}	
						/> */}
					</div>
					</Box>

				</Box>
				
			<AccountSaveEdit dataObj={dataObj} userObj={userObj} updatedList={updatedList} ref={childRefSaveEdit} />
			<AccountSaveNew dataObj={dataObj} userObj={userObj} updatedList={updatedList} ref={childRefSaveNew} />
			<AccountDetails dataObj={dataObj} userObj={userObj} privileges={privileges} closebtn={true} ref={childRefDetails} />						
			<AgentSelectMultiple userObj={userObj} dataObj={(selectedRows && selectedRows.length===1)?dataObj:{}} fetchDetail={shareToAgent} ref={childRefAddUser} />
			<UploadAccountData updatedList={reloadList} ref={childRefUpload} />

			<AgentSelect userObj={userObj} fetchDetail={transferLeadsToAgent} fetch={true} ref={childRefUser} />
			{overlayLoading?<OverlayLoadingScreen message="Please wait..." />:null}
			
				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete account.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={downloadShow}
					aria-labelledby="alert-dialog-section-title-a"
					aria-describedby="alert-dialog-section-description-a"
				>
					<DialogTitle id="alert-dialog-section-title-a">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description-a">
						<div style={{width:360}}>
						{downloadReady?<><div style={{textAlign:'center'}}><CircularProgress size={28} /></div>
						<br/>Wait..., It is creating CSV file to download</>:<>CSV file is ready to download</>}
						</div>
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					{!downloadReady?<><Button variant="outlined" size="small" onClick={()=>{downloadFile(2)}}>Cancel</Button><Button variant="contained" size="small" style={{backgroundColor:'#008000',color:'#FFF'}} onClick={()=>{downloadFile(3)}}>Download Now</Button></>:null}
					</DialogActions>
				</Dialog>

					
				<Authorization ref={childRefAuthorization} />
		</div>	
	);
  }